import { Component, DoCheck, OnDestroy, OnInit, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject, takeUntil } from 'rxjs';
import { FuseSidebarService } from '../../../shared/standalone-packages/ecap3/template-atlas';
import { ShellDomainProvider } from '../../../shared/standalone-packages/ecap3/core';
import { UrlResolverService } from '../../../shared/services/url/url-resolver.service';

@Component({
    selector: 'app-pcx-navbar',
    templateUrl: './pcx-navbar.component.html',
    styleUrls: ['./pcx-navbar.component.scss'],
    standalone: false
})
export class PcxNavbarComponent implements OnInit, OnDestroy {
    private readonly urlResolver = inject(UrlResolverService);
    siteLogo = ShellDomainProvider.api.SiteLogo;
    buildVersion = ShellDomainProvider.api.BuildVersion;
    backendBuildVersion: string = '';
    private destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(private _fuseSidebarService: FuseSidebarService, private httpClient: HttpClient) {}
    folded: Boolean = false;

    ngOnInit(): void {
        this.getBackEndVersion();
        this.folded = this._fuseSidebarService.getSidebar('navbar').folded;
    }

    /**
     * Toggle sidebar opened status
     */
    toggleSidebarOpened(): void {
        this._fuseSidebarService.getSidebar('navbar').toggleOpen();
        this.folded = this._fuseSidebarService.getSidebar('navbar').folded;
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        }, 0);
    }

    /**
     * Toggle sidebar folded status
     */
    toggleSidebarFolded(): void {
        this._fuseSidebarService.getSidebar('navbar').toggleFold();
        this.folded = this._fuseSidebarService.getSidebar('navbar').folded;
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        }, 0);
    }

    getBackEndVersion() {
        const url = `${this.urlResolver.getPcxQueryUrl()}GetBuildVersion`;
        this.httpClient
            .get(url, {
                responseType: 'text' as const
            })
            .pipe(takeUntil(this.destroy$))
            .subscribe(response => {
                this.backendBuildVersion = response;
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
}
